import React from "react";
import {cmpClassName} from "../../../common/generic-react.functions.js";
import {MainContainer} from "../../../common/generic-react.styles.js";
import DataTable from "../../molecules/data-table/data-table.component.js";
function ListSection({
  headers,
  items,
  options,
  columns,
  onPaginate
}) {
  return /* @__PURE__ */ React.createElement(MainContainer, {
    className: cmpClassName("list-section")
  }, /* @__PURE__ */ React.createElement(DataTable, {
    headers,
    items,
    options,
    columns,
    onPaginate
  }));
}
export default /* @__PURE__ */ React.memo(ListSection);
